import React from 'react'

import PropTypes from 'prop-types'
import { makeCachedStyles } from 'common/inline-styles'

//TODO: This will pull in styles from theme provider - probably
const useStyles = makeCachedStyles((__theme) => ({
    h5: {
        fontFamily: 'Montserrat',
        fontWeight: 500,
        fontSize: '1.333em',
    },
}))

export const H5 = ({ children, ...rest }) => {
    const classes = useStyles()
    return (
        <h5 className={classes.h5} {...rest}>
            {children}
        </h5>
    )
}

H5.propTypes = {
    children: PropTypes.node.isRequired,
    rest: PropTypes.any,
}
